import { userService } from '../_services';
import { router } from '../_helpers';

/*
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { items: user.basket }
    : { items: [] };
*/

export const basket = {
    namespaced: true,
    state: {
      items: []
    },
    actions: {
      update({ dispatch, commit }, { basket }){

        var user = JSON.parse(localStorage.getItem('user'))
        user.basket = basket
        localStorage.setItem('user', JSON.stringify(user));
        
        
        userService.updateBasket(basket)
          .then(
                basket => {
                    commit('updateRequest', { basket } );

                },
                error => {
                    commit('updateError', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
                    
                    
      }
    },
    mutations: {
      
        updateRequest(state){
            state.lastOrder = { loading: true };
        },
        updateSuccess(state, order){
            state.lastOrder = order ;
        },
        updateError(state, error ){
            state.lastOrder = { error };
        },
      
    }
}